import { useMemo } from "react"
import { Container } from "@chakra-ui/react"
import { Block, useStyletron } from "@mezo-org/mezo-clay"
import { Outlet } from "@tanstack/react-router"

import { selectIsConnected, useDappSelector } from "#/redux-state"
import { MAINNET_BANNER_HEIGHT } from "#/shared/constants"
import {
  useHomeRoute,
  useLandingRoute,
  useLeaderboardRoute,
  useMobileScreen,
} from "#/shared/hooks"
import { DashboardHeader, GridContainer, SidebarNavigation } from "#/ui/Layout"
import DashboardFooter from "#/ui/Layout/DashboardFooter"
import MatsnetTopBanner from "#/ui/Layout/MatsnetTopBanner"
import MainnetWelcomeModal from "#/ui/Modal/MainnetWelcomeModal"

import Header from "./Layout/Header"
import MobileView from "./Layout/MobileView"
import Footer from "./Footer"

export default function AppContainer() {
  const isMobileScreen = useMobileScreen()
  const isLeaderboardRoute = useLeaderboardRoute()
  const { isLandingRoute } = useLandingRoute()
  const isHomeRoute = useHomeRoute()

  const [, theme] = useStyletron()

  const isConnected = useDappSelector(selectIsConnected)

  const isMobileRoute = useMemo(
    () => isLandingRoute || isLeaderboardRoute || (!isConnected && isHomeRoute),
    [isLeaderboardRoute, isHomeRoute, isConnected, isLandingRoute],
  )

  const showMobileScreen = useMemo(
    () => isMobileScreen && !isMobileRoute,
    [isMobileScreen, isMobileRoute],
  )

  if (!isLandingRoute && showMobileScreen) {
    return <MobileView />
  }

  if (!isLandingRoute) {
    return (
      <>
        <MainnetWelcomeModal />

        <Block display="flex" flexDirection="column">
          <MatsnetTopBanner />
          <Block
            display="flex"
            minHeight={`calc(100vh - ${MAINNET_BANNER_HEIGHT}px)`}
          >
            {!isMobileScreen && <SidebarNavigation />}
            <GridContainer>
              <DashboardHeader />
              <Block
                maxWidth="1260px"
                padding={`${theme.sizing.scale800} ${
                  isMobileScreen
                    ? theme.sizing.scale1000
                    : theme.sizing.scale1600
                } ${
                  isMobileScreen
                    ? theme.sizing.scale1000
                    : theme.sizing.scale1600
                }`}
              >
                <Outlet />
              </Block>
              <DashboardFooter />
            </GridContainer>
          </Block>
        </Block>
      </>
    )
  }

  return (
    <>
      <Header />
      <Container
        maxW="100%"
        p={`${isLandingRoute ? "0" : "124px 0 0"} !important`}
      >
        <Outlet />
        {!isLandingRoute && <Footer />}
      </Container>
    </>
  )
}
